module.exports = __webpack_public_path__ + "static/media/HeartFilled.1cef265a.svg";